<template>
  <div>
    <b-modal
      id="tour-info-modal"
      ref="cruise-info-modal-ref"
      hide-footer
      title="Cruise Information"
    >
      <div v-if="cruiseData.operator && cruiseData.ship">
        <div class="row">
          <img
            :src="cruiseData.operator.profile_image_href['750x750']"
            class="vtd-center-image-profile"
            alt="ship profile image"
          >
        </div>

        <div class="row ship-name">
          <hr class="shipName-line">
          <span class="material-icons md-dark anchorL">anchor</span>
          {{ cruiseData.ship.title }}
          <span class="material-icons md-dark anchorR">anchor</span>
          <hr class="shipName-line">
        </div>

        <div class="container mt-3">
          <img
            :src="cruiseData.operator.cover_image_href['750x750']"
            class="vtd-center-image"
          >
        </div>

        <div class="row">
          <h6 class=" mt-4 my-2 ship-section-title">
            <span class="material-icons md-dark pr-1">support</span>
            Introduction
          </h6>
          <p
            class="text-left"
            v-html="cruiseData.ship.introduction"
          />
        </div>

        <div class="row" v-if="cruiseData.ship.unique_feature">
          <h6 class="ship-section-title my-2">
            <span class="material-icons md-dark pr-1">support</span> 
            Unique Feature
          </h6> 
          <div
            class="text-left"
            v-html="cruiseData.ship.unique_feature"
          />
        </div>

        <div class="row">
          <h6 class="ship-section-title my-3">
            <span class="material-icons md-dark pr-1">support</span> 
            Ship Facts
          </h6> 
        </div>
        <div class="text-left">
          <table class="table">
            <tr>
              <th>Guests:</th>
              <td>{{ cruiseData.ship.ship_facts.capacity }}</td>
            </tr>
            <tr>
              <th>Crew:</th>
              <td>{{ cruiseData.ship.ship_facts.crew_count }}</td>
            </tr>
            <tr>
              <th>Tonnage:</th>
              <td>{{ cruiseData.ship.ship_facts.gross_tonnage }} kg</td>
            </tr>
            <tr>
              <th>Length:</th>
              <td>{{ cruiseData.ship.ship_facts.length }} m</td>
            </tr>
            <tr>
              <th>Beam:</th>
              <td>{{ cruiseData.ship.ship_facts.width }} m</td>
            </tr>
            <tr>
              <th>Cruise Speed:</th>
              <td>{{ cruiseData.ship.ship_facts.speed }} knots</td> 
            </tr>
            <tr>
              <th>Launch Year:</th>
              <td>{{ cruiseData.ship.ship_facts.launch_year }}</td>
            </tr>
            <tr>
              <th>Refit Year:</th>
              <td>{{ cruiseData.ship.ship_facts.refit_year }}</td>
            </tr>
          </table>
        </div>

        <div class="row">
          <h6 class="my-4 ship-section-title">
            <span class="material-icons md-dark pr-1">support</span>
            Dining Options
          </h6>
          <b-carousel
            :interval="0"
            controls
            indicators
            background="#ababab"
            img-width="1024"
            img-height="480"
            style="text-shadow: 1px 1px 2px #333; box-shadow: 10px 10px 20px rgba(0, 0, 0, .2);"
          >
            <div
              v-for="(item, i) of cruiseData.ship.dining_options"
              :key="'carouselDining' + i"
            >
              <div v-if="item.images.length > 0">
                <b-carousel-slide
                  :caption="item.name"
                  :img-src="item.images[0].href['750x750']"
                />
              </div>
            </div>
          </b-carousel>

          <div
            v-for="(option, index) of cruiseData.ship.dining_options"
            :key="index"
            class="h6Child"
          >
            <h6><strong>{{ option.name }}</strong></h6>
            <div v-html="option.description" />
            <hr class="separator-line">
          </div>
        </div>

        <div class="row">
          <h6 class="ship-section-title my-4">
            <span class="material-icons md-dark pr-1">support</span>
            Entertainment
          </h6>
          <b-carousel
            :interval="0"
            controls
            indicators
            background="#ababab"
            img-width="1024"
            img-height="480"
            style="text-shadow: 1px 1px 2px #333; box-shadow: 10px 10px 20px rgba(0, 0, 0, .2);"
          >
            <div
              v-for="(item, i) of cruiseData.ship.entertainment_types"
              :key="'carouselEntertainment' + i"
            >
              <div v-if="item.images.length > 0">
                <b-carousel-slide
                  :caption="item.name"
                  :img-src="item.images[0].href['750x750']"
                />
              </div>
            </div>
          </b-carousel>

          <div
            v-for="(option, index) of cruiseData.ship.entertainment_types"
            :key="index"
            class="h6Child"
          >
            <h6><strong>{{ option.name }}</strong></h6>
            <div v-html="option.description" />
            <hr class="separator-line">
          </div>
        </div>

        <div class="row">
          <h6 class="ship-section-title my-4">
            <span class="material-icons md-dark pr-1">support</span>
            Health & Fitness
          </h6>
          <b-carousel
            :interval="0"
            controls
            indicators
            background="#ababab"
            img-width="1024"
            img-height="480"
            style="text-shadow: 1px 1px 2px #333; box-shadow: 10px 10px 20px rgba(0, 0, 0, .2);"
          >
            <div
              v-for="(item, i) of cruiseData.ship.health_fitness_types"
              :key="'carouselHealth' + i"
            >
              <div v-if="item.images.length > 0">
                <b-carousel-slide
                  :caption="item.name"
                  :img-src="item.images[0].href['750x750']"
                />
              </div>
            </div>
          </b-carousel>

          <div
            v-for="(type, index) of cruiseData.ship.health_fitness_types"
            :key="index"
            class="h6Child"
          >
            <h6><strong>{{ type.name }}</strong></h6>
            <div v-html="type.description" />
            <hr class="separator-line">
          </div>
        </div>

        <div v-if="cruiseData.ship.useful_types?.length" class="row">
          <h6 class="ship-section-title my-4">
            <span class="material-icons md-dark pr-1">support</span>
            Useful Information
          </h6>
          <section class="row">
            <div
              v-for="(useful, index) of cruiseData.ship.useful_types"
              :key="index"
              class="col-12 col-sm-6 col-md-4 mb-4"
            >
              <div class="card useful-info-card rounded-0 border-0 shadow-sm h-100">
                <div class="card-body d-flex flex-column">
                  <div class="useful-info-icon">
                    <span class="material-icons">info</span>
                  </div>
                  <h5 class="card-title text-strong mt-3">{{ useful.name }}</h5>
                  <div class="useful-info-desc" v-html="useful.description" />
                </div>
              </div>
            </div>
          </section>
        </div>

        <div
          v-if="cruiseData.ship.deckplans.length > 0"
          class="row"
        >
          <div class="col-md-12 pl-0">
            <h6 class="my-4 ship-section-title">
              <span class="material-icons md-dark pr-1">support</span>
              Deck Plans
            </h6>
          </div>
          <div
            v-for="(deckplan, index) in cruiseData.ship.deckplans"
            :key="index"
          >
            <div v-if="deckplan.images.length > 0">
              <h6>{{ deckplan.name }}</h6>
              <div v-html="deckplan.description" />
              <div class="col-md-12 text-none">
                <img
                  class="vtd-center-image"
                  :src="deckplan.images[0].href['750x750']"
                  loading="lazy"
                >
              </div>
              <hr class="separator-line">
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>

export default {
  props: {
    item: null,
    cruiseData: null,
  },
  methods: {
    show(htlpagelink) {
      this.$refs["cruise-info-modal-ref"].show();
    },
    
  },
};
</script>

<style lang="scss" scoped>
.infoBoxIframe {
  height: 590px;
  width: 100%;
}
.ship-name {
  font-size: 1.7rem;
  color: #006994;
  font-weight: 600;
  display: block;
  text-align: center;
  margin-top: 2rem;
  letter-spacing: 2px;
}
.anchorL {
  padding-right: 12px; 
}
.anchorR {
  padding-left: 12px; 
}
.vtd-center-image-profile {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 30%;
}
.vtd-center-image {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}
.ship-section-title {
  color: #006994;
  font-weight: bolder;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.shipName-line {
  width: 90%;
  height: 0px;
  border: none;
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;
  border-top: 2px solid #006994;
}
.separator-line {
  width: 100%;
  height: 0px;
  border: none;
  border-top: 1px solid #006994;
}
.h6Child:nth-child(3) > h6 {
  margin-top: 1.7rem;
}
.useful-info-card {
  border-top: 3px solid #ffa409;
  padding: 1rem;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.useful-info-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 0.75rem 1.5rem rgba(0, 0, 0, 0.12) !important;
}
.useful-info-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background-color: #fff4e0;
}
.useful-info-icon .material-icons {
  color: #ffa409;
  font-size: 1.5rem;
}
.useful-info-desc {
  max-height: 9rem;
  overflow-y: auto;
}

@media only screen and (max-width: 500px) {
  .ship-name {
    font-size: 1.2rem;
    letter-spacing: 0px;
  } 
  .anchorL {
    font-size: 1rem;
    padding: 0;
  }
  .anchorR {
    font-size: 1rem;
    padding: 0;
  }
  .shipName-line {
    width: 85%;
  }
}
</style>
